class FacetFiltersForm extends HTMLElement{constructor(){super();this.onActiveFilterClick=this.onActiveFilterClick.bind(this);this.debouncedOnSubmit=debounce((event)=>{this.onSubmitHandler(event)},500);const facetForm=this.querySelector("form");facetForm.addEventListener("input",this.debouncedOnSubmit.bind(this));const facetWrapper=this.querySelector("#FacetsWrapperDesktop");if(facetWrapper)facetWrapper.addEventListener("keyup",onKeyUpEscape);}
connectedCallback(){const facetForm=this.querySelector("form");facetForm.addEventListener("input",this.debouncedOnSubmit.bind(this))}
static setListeners(){const onHistoryChange=(event)=>{const searchParams=event.state?event.state.searchParams:FacetFiltersForm.searchParamsInitial;if(searchParams===FacetFiltersForm.searchParamsPrev)return;FacetFiltersForm.renderPage(searchParams,null,!1)};window.addEventListener("popstate",onHistoryChange)}
static toggleActiveFacets(disable=!0){document.querySelectorAll(".js-facet-remove").forEach((element)=>{element.classList.toggle("disabled",disable)})}
static fireCustomEvent(options){const facetsChange=new CustomEvent("facets:change",{bubbles:!0,cancelable:!0,detail:{desc:"facets changed",...options,},});document.dispatchEvent(facetsChange)}
static renderPage(searchParams,event,updateURLHash=!0){FacetFiltersForm.searchParamsPrev=searchParams;const sections=FacetFiltersForm.getSections();const countContainer=document.getElementById("ProductCount");const countContainerDesktop=document.getElementById("ProductCountDesktop",);sections.forEach((section)=>{const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`;const filterDataUrl=(element)=>element.url===url;FacetFiltersForm.filterData.some(filterDataUrl)?FacetFiltersForm.renderSectionFromCache(filterDataUrl,event):FacetFiltersForm.renderSectionFromFetch(url,event)});if(updateURLHash)FacetFiltersForm.updateURLHash(searchParams);}
static renderSectionFromFetch(url,event){fetch(url).then((response)=>response.text()).then((responseText)=>{const html=responseText;FacetFiltersForm.filterData=[...FacetFiltersForm.filterData,{html,url},];const parser=new DOMParser();const parsedHTML=parser.parseFromString(html,'text/html')
const newActiveFilters=parsedHTML.querySelector('[active-filters]')?.innerText?.replace('var activeFilters = ','');if(newActiveFilters)activeFilters=JSON.parse(newActiveFilters);FacetFiltersForm.renderFilters(html,event);FacetFiltersForm.renderProductGridContainer(html);if(typeof initializeScrollAnimationTrigger==="function")
initializeScrollAnimationTrigger(html.innerHTML);}).finally(()=>FacetFiltersForm.fireCustomEvent())}
static renderSectionFromCache(filterDataUrl,event){const html=FacetFiltersForm.filterData.find(filterDataUrl).html;FacetFiltersForm.renderFilters(html,event);FacetFiltersForm.renderProductGridContainer(html);if(typeof initializeScrollAnimationTrigger==="function")
initializeScrollAnimationTrigger(html.innerHTML);}
static renderProductGridContainer(html){document.getElementById("ProductGridContainer").innerHTML=new DOMParser().parseFromString(html,"text/html").getElementById("ProductGridContainer").innerHTML}
static renderProductCount(html){const count=new DOMParser().parseFromString(html,"text/html").getElementById("ProductCount").innerHTML;const container=document.getElementById("ProductCount");const containerDesktop=document.getElementById("ProductCountDesktop");container.innerHTML=count;container.classList.remove("loading");if(containerDesktop){containerDesktop.innerHTML=count;containerDesktop.classList.remove("loading")}}
static renderFilters(html,event){const parsedHTML=new DOMParser().parseFromString(html,"text/html");const facetDetailsElements=parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",);const matchesIndex=(element)=>{const jsFilter=event?event.target.closest(".js-filter"):undefined;return jsFilter?element.dataset.index===jsFilter.dataset.index:!1};const facetsToRender=Array.from(facetDetailsElements).filter((element)=>!matchesIndex(element),);const countsToRender=Array.from(facetDetailsElements).find(matchesIndex);facetsToRender.forEach((element)=>{const newElement=element;const tabIndexElements=newElement.querySelectorAll(".wt-collapse__trigger",);tabIndexElements.forEach((el)=>el.setAttribute("tabindex","0"));const container=document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`,);container.innerHTML="";container.appendChild(newElement)});FacetFiltersForm.renderActiveFacets(parsedHTML);FacetFiltersForm.renderAdditionalElements(parsedHTML);if(countsToRender)
FacetFiltersForm.renderCounts(countsToRender,event.target.closest(".js-filter"),);}
static renderActiveFacets(html){const activeFacetElementSelectors=[".active-facets"];activeFacetElementSelectors.forEach((selector)=>{const activeFacetsElement=html.querySelector(selector);if(!activeFacetsElement)return;document.querySelector(selector).innerHTML=activeFacetsElement.innerHTML});FacetFiltersForm.toggleActiveFacets(!1)}
static renderAdditionalElements(html){const mobileElementSelectors=[".mobile-facets__open",".mobile-facets__count",".sorting",];mobileElementSelectors.forEach((selector)=>{if(!html.querySelector(selector))return;document.querySelector(selector).innerHTML=html.querySelector(selector).innerHTML})}
static renderCounts(source,target){const targetElement=target.querySelector(".facets__selected");const sourceElement=source.querySelector(".facets__selected");const targetElementAccessibility=target.querySelector(".facets__summary");const sourceElementAccessibility=source.querySelector(".facets__summary");if(sourceElement&&targetElement){target.querySelector(".facets__selected").outerHTML=source.querySelector(".facets__selected").outerHTML}
if(targetElementAccessibility&&sourceElementAccessibility){target.querySelector(".facets__summary").outerHTML=source.querySelector(".facets__summary").outerHTML}}
static updateURLHash(searchParams){history.pushState({searchParams},"",`${window.location.pathname}${searchParams && "?".concat(searchParams)}`,)}
static getSections(){return[{section:document.getElementById("product-grid").dataset.id,},]}
createSearchParams(form){const formData=new FormData(form);return new URLSearchParams(formData).toString()}
onSubmitForm(searchParams,event){FacetFiltersForm.renderPage(searchParams,event)}
onSubmitHandler(event){event.preventDefault();const sortFilterForms=document.querySelectorAll("facet-filters-form form",);if(event.srcElement.className=="mobile-facets__checkbox"){const searchParams=this.createSearchParams(event.target.closest("form"),);this.onSubmitForm(searchParams,event)}else{const forms=[];const isMobile=event.target.closest("form").id==="FacetFiltersFormMobile";sortFilterForms.forEach((form)=>{if(!isMobile){if(form.id==="FacetSortForm"||form.id==="FacetFiltersForm"||form.id==="FacetSortDrawerForm"){const noJsElements=document.querySelectorAll(".no-js-list");noJsElements.forEach((el)=>el.remove());forms.push(this.createSearchParams(form))}}else if(form.id==="FacetFiltersFormMobile"){forms.push(this.createSearchParams(form))}});this.onSubmitForm(forms.join("&"),event)}}
onActiveFilterClick(event){event.preventDefault();FacetFiltersForm.toggleActiveFacets();const url=event.currentTarget.href.indexOf("?")==-1?"":event.currentTarget.href.slice(event.currentTarget.href.indexOf("?")+1,);FacetFiltersForm.renderPage(url)}}
FacetFiltersForm.filterData=[];FacetFiltersForm.searchParamsInitial=window.location.search.slice(1);FacetFiltersForm.searchParamsPrev=window.location.search.slice(1);customElements.define("facet-filters-form",FacetFiltersForm);FacetFiltersForm.setListeners();class PriceRange extends HTMLElement{constructor(){super();this.querySelectorAll("input").forEach((element)=>element.addEventListener("input",this.onRangeChange.bind(this)),);this.setMinAndMaxValues()}
onRangeChange(event){this.adjustToValidValues(event.currentTarget);this.setMinAndMaxValues()}
setMinAndMaxValues(){const inputs=this.querySelectorAll("input");const minInput=inputs[0];const maxInput=inputs[1];if(maxInput.value)minInput.setAttribute("max",maxInput.value.trim());if(minInput.value)maxInput.setAttribute("min",minInput.value.trim());if(minInput.value==="")maxInput.setAttribute("min",0);if(maxInput.value==="")
minInput.setAttribute("max",maxInput.getAttribute("max"));}
adjustToValidValues(input){const fromInput=this.querySelector('[name="filter.v.price.gte"]');const toInput=this.querySelector('[name="filter.v.price.lte"]');const sliderEl=this.querySelector(".f-price__slider");const globalMax=sliderEl?Number(sliderEl.dataset.max)||999999:999999;let fromValue=parseFloat(fromInput.value)||0;let toValue=parseFloat(toInput.value)||0;if(input.name==="filter.v.price.gte"){if(fromValue<0){fromValue=0}
if(fromValue>toValue){fromValue=toValue}
if(fromValue>globalMax){fromValue=globalMax}
fromInput.value=fromValue}else{if(toValue<fromValue){toValue=fromValue}
if(toValue>globalMax){toValue=globalMax}
toInput.value=toValue}}}
customElements.define("price-range",PriceRange);class FacetRemove extends HTMLElement{constructor(){super();const facetLink=this.querySelector("a");facetLink.setAttribute("role","button");facetLink.addEventListener("click",this.closeFilter.bind(this));facetLink.addEventListener("keyup",(event)=>{if(event.code.toUpperCase()==="SPACE"){event.preventDefault();this.closeFilter(event)}});FacetFiltersForm.fireCustomEvent()}
closeFilter(event){event.preventDefault();const form=this.closest("facet-filters-form")||document.querySelector("facet-filters-form");const priceRanges=document.querySelectorAll(".f-price__inputs > .f-price__val",);if((event.target.className==="filter__remove"||event.target.parentNode.classList.contains("price_range"))&&priceRanges){const priceSlider=document.querySelector(".f-price__slider");if(priceSlider){const maxPrice=document.querySelectorAll("price-range > div")[0].getAttribute("data-max");const currency=document.querySelectorAll("price-range > div")[0].getAttribute("data-currency");const minPriceRange=priceRanges[0].querySelector("input");const maxPriceRange=priceRanges[1].querySelector("input");priceSlider.noUiSlider.set([priceSlider.dataset.min,priceSlider.dataset.max,]);minPriceRange.value=0;minPriceRange.max=maxPrice;maxPriceRange.value=maxPrice;maxPriceRange.min=0}}
form.onActiveFilterClick(event)}}
customElements.define("facet-remove",FacetRemove)

/* ===================== TITLE FİLTRELEME SİSTEMİ ===================== */

// İç giyim koleksiyonları - kısmi eşleştirme için
// NOT: Türkçe İ karakteri URL'de i%CC%87 veya iç olarak kodlanıyor
// Bu yüzden 'ic-giyim' yerine 'c-giyim' kullanıyoruz (her iki kodlamayı da yakalar)
const UNDERWEAR_COLLECTION_PATTERNS = [
  'c-giyim', 'sutyen', 'kulot', 'jartier', 'body', 'korse',
  'lazer-kesim', 'ic-giyim-aksesuar'
];

// İç giyim filtre config'i
const UNDERWEAR_FILTER_CONFIG = {
  'cup': {
    'A Cup': ['A Cup'],
    'B Cup': ['B Cup', 'B CUP'],
    'C Cup': ['C Cup', 'C CUP'],
    'D Cup': ['D Cup', 'D CUP'],
    'E Cup': ['E Cup', 'E CUP'],
    'F Cup': ['F Cup', 'F CUP']
  },
  'ic_model_detay': {
    'Destekli': ['Destekli'],
    'Desteksiz': ['Desteksiz'],
    'Çift Destekli': ['Çift Destekli'],
    'Basic': ['Basic'],
    'Dantelli': ['Dantelli'],
    'Yarım Destekli': ['Yarım Destekli'],
    'Lazer Kesim': ['Lazer Kesim', 'Lazer'],
    'Minimizer': ['Minimizer'],
    'Toparlayıcı': ['Toparlayıcı'],
    'Balensiz': ['Balensiz'],
    'Dolgusuz': ['Dolgusuz'],
    'Dikişsiz': ['Dikişsiz'],
    'Slip': ['Slip'],
    'Bato': ['Bato'],
    'Brazilian': ['Brazilian', 'Brazillian'],
    'Hipster': ['Hipster'],
    'String': ['String'],
    'Yüksek Bel': ['Yüksel Bel', 'Yüksek Bel', 'Yuksek Bel'],
    'Straplez': ['Straplez'],
    'Soft Cup': ['Soft Cup', 'Soft'],
    'Çıkarılabilir Pedli': ['Çıkarılabilir Pedli'],
    'Askılı': ['Askılı']
  }
};

// Ev giyim filtre config'i
const TITLE_FILTER_CONFIG = {
  'yaka_tipi': {
    'Bisiklet Yaka': ['O YAKA', 'BISIKLET YAKA', 'BİSİKLET YAKA', 'OYAKA'],
    'V Yaka': ['V YAKA', 'VYAKA', 'V DETAYLI', 'V PAT YAKA'],
    'Kayık Yaka': ['KAYIK YAKA'],
    'Şal Yaka': ['SAL YAKALI', 'SAL YAKA'],
    'Polo Yaka': ['POLO YAKA'],
    'Damla Yaka': ['DAMLA YAKA'],
    'Gömlek Yaka': ['GOMLEK YAKALI', 'GOMLEK YAKA'],
    'Balıkçı Yaka': ['BALIKCI YAKA'],
    'Sandık Yaka': ['SANDIK YAKA'],
    'Hakim Yaka': ['HAKIM YAKA'],
    'Dik Yaka': ['DIK YAKA'],
    'U Yaka': ['U YAKA'],
    'Ceket Yaka': ['CEKET YAKA']
  },
  'kol_tipi': {
    'Kısa Kol': ['KISA KOL', 'KEP KOL', 'KISA KOLU', 'K.KOL'],
    'Uzun Kol': ['UZUN KOL'],
    'Fakir Kol': ['3/4KOL', '3/4 KOL', 'TUNIK+3/4KOL', '3/4KOLUCU'],
    'Yarasa Kol': ['YARASA KOL'],
    'Kolsuz': ['IP ASKILI', 'KALIN ASKILI', 'SIFIR KOL', 'GENIS ASKILI', 'KOLSUZ', 'ASKILI'],
    'Reglan Kol': ['REGLAN'],
    'Düşük Omuz': ['DUSUK OMUZLU'],
    'Duble Kol': ['DOUBLE KOL', 'DOUBLE 7/8KOL', 'KOLAGZI DOUBLE', 'KOLUCU DOUBLE'],
    'Balon Kol': ['BALON KOL']
  },
  'cep_detay': {
    'Cepli': ['CEPLI', 'CEPLİ'],
    'Cepsiz': [] // Özel mantık: CEPLI/CEPLİ içermeyenler
  },
  'model_detay': {
    'Dantelli': ['DANTELLI'],
    'Manşetli': ['MANSETLI'],
    'Fermuarlı': ['FERMUARLI'],
    'Düğmeli': ['PATLI', 'DUGMELI'],
    'Kapüşonlu': ['KAPSONLU', 'KAPISONLU'],
    'Büzgülü': ['BUZGULU', 'BUZGU'],
    'Bibilalı': ['BIBILALI'],
    'Yırtmaçlı': ['YIRTMACLI'],
    'Duble Paça': ['DOUBLE PACA', 'DOUBLE KATLAMA PACA'],
    'Apoletli': ['APOLETLI'],
    'Bağcıklı': ['BAGCIKLI'],
    'Fırfırlı': ['FIRFIRLI', 'FIRLIRLI'],
    'Eteği Oval': ['ETEGI OVAL'],
    'Tek Omuz': ['TEK OMUZLU'],
    'Fiyonklu': ['FIYONKLU', 'FIYONK'],
    'Lastikli Bel': ['BELI LASTIKLI'],
    'Pervazlı': ['PERVAZLI'],
    'Pileli': ['PILILI'],
    'Nervürlü': ['NERVURLU'],
    'Çıtçıtlı': ['CITCITLI'],
    'Kemerli': ['KEMERLI'],
    'Nakışlı': ['NAKISLI', 'NAKIS'],
    'Aksesuarlı': ['AKSESUARLI'],
    'Kroşetalı': ['KROSETALI']
  },
  'kumas': {
    'Suprem': ['P.SUPREM', 'P.SUPREM/3IPLIK', 'PENYE SUPREM', 'SUPREM'],
    'Polar': ['POLAR'],
    'Kadife': ['KADIFE'],
    'Welsoft': ['SOFT', 'WELSOFT', 'J.ULTRASOFT', 'SUPERSOFT'],
    'Üç İplik': ['3IPLIK', 'P.SUPREM/3IPLIK', '3 IPLIK'],
    'İki İplik': ['2IPLIK', 'IKI IPLIK', '2 IPLIK'],
    'Muslin': ['MUSLIN'],
    'LYC Worteks': ['LYC WORTEKS', 'LYC WORTEKS/LYC SUPREM'],
    'Polyviscon': ['POLYVISCON', 'P.VISCON/LYC SUPREM', 'P.VISCON', 'LYC POLYVISCON'],
    'Viscon': ['VISCON'],
    'Saten': ['SATEN', 'SATEEN'],
    'Jakar': ['JAKARLI', 'JAKARLI INTERLOK'],
    'İnterlok': ['INTERLOK', 'JAKARLI INTERLOK'],
    'Modal': ['P.MODAL', 'MODAL'],
    'Kapitone': ['KAPITONE'],
    'Microsoft Suprem': ['MICROSOFT SUPREM'],
    'Microsoft Marla': ['MICROSOFT MARLA'],
    'Termal': ['COMFORT'],
    'LYC Suprem': ['LYC SUPREM', 'LYC WORTEKS/LYC SUPREM', 'P.VISCON/LYC SUPREM'],
    'Belmando': ['BELMANDO'],
    'Keten': ['KETEN'],
    'Koton': ['MARAŞ', 'MARAS', 'PAMUK', 'KOTON'],
    'LYC Modal': ['LYC MODAL'],
    'Kaşkorse': ['LYC KASKORSE', 'KASKORSE'],
    'LYC Rejenere': ['LYC REJENERE'],
    'Dokuma': ['DOKUMA'],
    'Scuba': ['SCUBA'],
    'Brode': ['BRODE'],
    'Ayrobin': ['AYROBIN'],
    'Kıbrıs': ['KIBRIS'],
    'Waffle': ['WAFFLE', 'VAFFLE'],
    'Bukle': ['BUKLE'],
    'Triga': ['TRIGA'],
    'Marla': ['MARLA']
  }
};

// Title filtreleme sistemi
class TitleFilterSystem {
  constructor() {
    this.allProducts = null; // Cache için
    this.activeFilters = {}; // { yaka_tipi: ['Bisiklet Yaka', 'V Yaka'], kol_tipi: ['Kısa Kol'] }
    this.isLoading = false;
    this.loadingPromise = null; // Preload promise
    this.originalHTML = null; // Orijinal grid HTML'i
    this.facetsChangeTimeout = null; // facets:change debounce için

    // Koleksiyon tipini belirle (iç giyim veya ev giyim)
    this.collectionHandle = this.getCollectionHandle();
    // Kısmi eşleştirme kullan - Unicode karakter sorunlarını çözmek için
    this.isUnderwearCollection = this.checkIsUnderwearCollection();
    this.filterConfig = this.isUnderwearCollection ? UNDERWEAR_FILTER_CONFIG : TITLE_FILTER_CONFIG;

    console.log(`[TitleFilter] 🏷️ Koleksiyon: ${this.collectionHandle} (${this.isUnderwearCollection ? 'İç Giyim' : 'Ev Giyim'})`);

    this.init();
  }

  init() {
    // Checkbox'lara event listener ekle
    const checkboxes = document.querySelectorAll('.title-filter-checkbox');
    console.log(`[TitleFilter] 📋 Checkbox: ${checkboxes.length}`);

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.onFilterChange(e));
    });

    // Temizle butonuna event listener
    const clearBtn = document.getElementById('clear-title-filters');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => this.clearAllFilters());
    }

    // Grid ve ürün sayısı kontrolü
    const grid = document.getElementById('product-grid');
    const items = grid ? grid.querySelectorAll('.collection__grid__item') : [];
    console.log(`[TitleFilter] 📦 Grid: ${!!grid}, Ürün: ${items.length}`);

    // FacetFiltersForm'un grid'i değiştirmesinden sonra filtrelerimizi yeniden uygula (debounced)
    document.addEventListener('facets:change', () => {
      // Aktif filtre yoksa işlem yapma
      if (Object.keys(this.activeFilters).length === 0) return;

      // Zaten bekleyen bir timeout varsa iptal et (debounce)
      if (this.facetsChangeTimeout) {
        clearTimeout(this.facetsChangeTimeout);
      }

      console.log('[TitleFilter] 🔄 facets:change algılandı (debounced)');

      // Kısa bir gecikme ile yeniden uygula (DOM güncellensin + debounce)
      this.facetsChangeTimeout = setTimeout(() => {
        this.facetsChangeTimeout = null;

        if (Object.keys(this.activeFilters).length > 0) {
          console.log('[TitleFilter] 🔄 Filtreler yeniden uygulanıyor...');

          // Orijinal HTML'i güncelle (yeni Shopify sonuçlarıyla)
          const gridEl = document.getElementById('product-grid');
          if (gridEl) {
            this.originalHTML = gridEl.innerHTML;
          }

          // Ürünler zaten yüklüyse sadece filtrele (yeniden yükleme)
          if (this.allProducts && this.allProducts.length > 0) {
            const filteredProducts = this.filterProducts(this.allProducts);
            console.log(`[TitleFilter] 🎯 Sonuç: ${filteredProducts.length}/${this.allProducts.length} ürün`);
            this.renderFilteredProducts(filteredProducts);
          }
        }
      }, 200);
    });

    // URL'den filtreleri yükle
    this.loadFiltersFromURL();

    console.log('[TitleFilter] ✅ Başlatıldı, preload başlıyor...');

    // PRELOAD: Sayfa açıldığında hemen arka planda yükle
    this.preloadProducts();
  }

  // URL'den filtreleri yükle
  loadFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    let hasFilters = false;

    for (const key of Object.keys(this.filterConfig)) {
      const paramValue = params.get(`tf_${key}`);
      if (paramValue) {
        const selectedValues = paramValue.split(',');
        this.activeFilters[key] = selectedValues;
        hasFilters = true;

        // Checkbox'ları işaretle
        selectedValues.forEach(value => {
          const checkbox = document.querySelector(
            `.title-filter-checkbox[data-filter-key="${key}"][data-filter-value="${value}"]`
          );
          if (checkbox) checkbox.checked = true;
        });
      }
    }

    if (hasFilters) {
      console.log('[TitleFilter] 📥 URL\'den filtreler yüklendi:', this.activeFilters);
      this.toggleClearButton();
      // Preload sonrası filtreleme yapılacak
      setTimeout(() => this.applyFilters(), 500);
    }
  }

  // URL'i güncelle
  updateURL() {
    const params = new URLSearchParams(window.location.search);

    // Önce tüm tf_ parametrelerini temizle
    for (const key of [...params.keys()]) {
      if (key.startsWith('tf_')) {
        params.delete(key);
      }
    }

    // Aktif filtreleri ekle
    for (const [key, values] of Object.entries(this.activeFilters)) {
      if (values.length > 0) {
        params.set(`tf_${key}`, values.join(','));
      }
    }

    // URL'i güncelle (sayfa yenilemeden)
    const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    history.replaceState(null, '', newURL);
    console.log('[TitleFilter] 🔗 URL güncellendi');
  }

  // Arka planda tüm ürünleri yükle
  preloadProducts() {
    // Zaten yükleniyor veya yüklendiyse çık
    if (this.loadingPromise || this.allProducts) return;

    this.loadingPromise = this.loadAllProducts(true); // silent mode
  }

  // Filtre değişikliğinde çağrılır
  async onFilterChange(e) {
    // FacetFiltersForm'un bu event'i yakalamasını engelle
    e.stopPropagation();
    e.preventDefault();

    const checkbox = e.target;
    const filterKey = checkbox.dataset.filterKey;
    const filterValue = checkbox.dataset.filterValue;

    console.log(`[TitleFilter] 🔍 ${filterKey}: ${filterValue} (${checkbox.checked ? '+' : '-'})`);

    // Aktif filtreleri güncelle
    if (!this.activeFilters[filterKey]) {
      this.activeFilters[filterKey] = [];
    }

    if (checkbox.checked) {
      if (!this.activeFilters[filterKey].includes(filterValue)) {
        this.activeFilters[filterKey].push(filterValue);
      }
    } else {
      this.activeFilters[filterKey] = this.activeFilters[filterKey].filter(v => v !== filterValue);
      if (this.activeFilters[filterKey].length === 0) {
        delete this.activeFilters[filterKey];
      }
    }

    // Temizle butonunu göster/gizle
    this.toggleClearButton();

    // Filtreleme yap
    await this.applyFilters();
  }

  // Temizle butonunu göster/gizle
  toggleClearButton() {
    const clearBtn = document.querySelector('.title-filters-clear');
    if (clearBtn) {
      const hasActiveFilters = Object.keys(this.activeFilters).length > 0;
      clearBtn.style.display = hasActiveFilters ? 'block' : 'none';
    }
  }

  // Tüm filtreleri temizle
  clearAllFilters() {
    this.activeFilters = {};

    // Checkbox'ları temizle
    document.querySelectorAll('.title-filter-checkbox').forEach(cb => {
      cb.checked = false;
    });

    this.toggleClearButton();
    this.restoreOriginalGrid();

    // URL'i temizle
    this.updateURL();
  }

  // Orijinal grid'i geri yükle
  restoreOriginalGrid() {
    if (this.originalHTML) {
      const grid = document.getElementById('product-grid');
      if (grid) {
        grid.innerHTML = this.originalHTML;
        // Pagination'ı göster
        const pagination = document.querySelector('.wt-pagination-wrapper');
        if (pagination) pagination.style.display = '';
      }
    }
    // Sayfa yenile (normal Shopify davranışına dön)
    // window.location.reload();
  }

  // Filtreleri uygula
  async applyFilters() {
    console.log('[TitleFilter] ⚙️ Filtreler:', JSON.stringify(this.activeFilters));

    const hasActiveFilters = Object.keys(this.activeFilters).length > 0;

    if (!hasActiveFilters) {
      console.log('[TitleFilter] 🔄 Reset');
      this.restoreOriginalGrid();
      return;
    }

    // Orijinal HTML'i kaydet (ilk seferde)
    if (!this.originalHTML) {
      const grid = document.getElementById('product-grid');
      if (grid) {
        this.originalHTML = grid.innerHTML;
      }
    }

    // Preload devam ediyorsa bekle
    if (this.loadingPromise) {
      console.log('[TitleFilter] ⏳ Preload bekleniyor...');
      this.showLoading();
      await this.loadingPromise;
      this.hideLoading();
    }

    // Hala yüklenmemişse yükle
    if (!this.allProducts) {
      await this.loadAllProducts(false);
    }

    if (!this.allProducts || this.allProducts.length === 0) {
      console.warn('[TitleFilter] ⚠️ Ürünler yüklenemedi');
      return;
    }

    // Filtreleme yap
    const filteredProducts = this.filterProducts(this.allProducts);
    console.log(`[TitleFilter] 🎯 Sonuç: ${filteredProducts.length}/${this.allProducts.length} ürün`);

    // Sonuçları göster
    this.renderFilteredProducts(filteredProducts);

    // URL'i güncelle
    this.updateURL();
  }

  // Tüm ürünleri yükle (HTML sayfalarından)
  // silent=true: arka plan preload (loading gösterme)
  async loadAllProducts(silent = false) {
    if (this.isLoading) {
      // Zaten yükleniyorsa, mevcut promise'i bekle
      if (this.loadingPromise) await this.loadingPromise;
      return;
    }
    this.isLoading = true;

    // Loading göster (silent değilse)
    if (!silent) this.showLoading();

    try {
      const collectionHandle = this.getCollectionHandle();
      let allProducts = [];

      console.log(`[TitleFilter] 📦 ${silent ? '(preload)' : ''} ${collectionHandle}`);

      // İlk sayfadaki ürünleri DOM'dan al
      const firstPageProducts = this.getProductsFromDOM();
      allProducts = allProducts.concat(firstPageProducts);
      console.log(`[TitleFilter]    S1: ${firstPageProducts.length}`);

      // Toplam sayfa sayısını bul
      const totalPages = this.getTotalPages();
      console.log(`[TitleFilter]    Toplam sayfa: ${totalPages}`);

      if (totalPages <= 1) {
        this.allProducts = allProducts;
        console.log(`[TitleFilter] ✅ Toplam: ${allProducts.length} (tek sayfa)`);
        return;
      }

      // PARALEL FETCH: Tüm sayfaları aynı anda çek (3'erli gruplar halinde)
      const pagesToFetch = [];
      for (let p = 2; p <= totalPages; p++) {
        pagesToFetch.push(p);
      }

      // 3'erli gruplar halinde paralel fetch (rate limiting için)
      const chunkSize = 3;
      for (let i = 0; i < pagesToFetch.length; i += chunkSize) {
        const chunk = pagesToFetch.slice(i, i + chunkSize);
        console.log(`[TitleFilter]    S${chunk.join(',')} yükleniyor...`);

        const results = await Promise.all(
          chunk.map(page => this.fetchPage(page))
        );

        results.forEach((pageProducts, idx) => {
          if (pageProducts.length > 0) {
            allProducts = allProducts.concat(pageProducts);
            console.log(`[TitleFilter]    S${chunk[idx]}: ${pageProducts.length}`);
          }
        });

        // Gruplar arası kısa bekleme
        if (i + chunkSize < pagesToFetch.length) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      this.allProducts = allProducts;
      console.log(`[TitleFilter] ✅ Toplam: ${allProducts.length} (${totalPages} sayfa)`);

    } catch (error) {
      console.error('[TitleFilter] ❌ Hata:', error);
      this.allProducts = this.getProductsFromDOM();
    } finally {
      this.isLoading = false;
      this.loadingPromise = null;
      if (!silent) this.hideLoading();
    }
  }

  // Tek sayfa fetch et
  async fetchPage(page) {
    try {
      // Mevcut URL parametrelerini koru (sort, fiyat filtresi vs.)
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('page', page);
      const url = `${window.location.pathname}?${currentParams.toString()}`;

      const response = await fetch(url);
      if (!response.ok) return [];

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const products = [];
      doc.querySelectorAll('#product-grid .collection__grid__item').forEach(item => {
        const card = item.querySelector('.card__container');
        // Title kullan (data-product-title attribute'u veya .card__title içeriği)
        const title = card?.dataset?.productTitle || card?.querySelector('.card__title')?.textContent || '';
        const itemHtml = item.outerHTML;
        if (title) {
          products.push({ title, html: itemHtml });
        }
      });
      return products;
    } catch (e) {
      return [];
    }
  }

  // Toplam sayfa sayısını bul
  getTotalPages() {
    // Pagination linklerinden son sayfa numarasını bul
    const paginationLinks = document.querySelectorAll('.wt-pagination .wt-pagination__item');
    let maxPage = 1;

    paginationLinks.forEach(link => {
      const text = link.textContent.trim();
      const num = parseInt(text);
      if (!isNaN(num) && num > maxPage) {
        maxPage = num;
      }
    });

    return maxPage;
  }

  // DOM'dan mevcut ürünleri al
  getProductsFromDOM() {
    const products = [];
    document.querySelectorAll('#product-grid .collection__grid__item').forEach(item => {
      const card = item.querySelector('.card__container');
      // Title kullan (data-product-title attribute'u veya .card__title içeriği)
      const title = card?.dataset?.productTitle || card?.querySelector('.card__title')?.textContent || '';
      const itemHtml = item.outerHTML;
      if (title) {
        products.push({ title, html: itemHtml });
      }
    });
    return products;
  }

  // Collection handle'ını al
  getCollectionHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/collections\/([^\/\?]+)/);
    return match ? match[1] : 'all';
  }

  // İç giyim koleksiyonu mu kontrol et (kısmi eşleştirme)
  checkIsUnderwearCollection() {
    const path = window.location.pathname.toLowerCase();
    // URL decode yap (i%CC%87 -> iç gibi)
    const decodedPath = decodeURIComponent(path);

    // UNDERWEAR_COLLECTION_PATTERNS'daki herhangi bir pattern path'de var mı?
    return UNDERWEAR_COLLECTION_PATTERNS.some(pattern => {
      return path.includes(pattern) || decodedPath.includes(pattern);
    });
  }

  // Ürünleri filtrele (title'a göre)
  filterProducts(products) {
    // DEBUG: İlk 3 ürünün title'ını göster
    console.log('[TitleFilter] DEBUG - İlk 3 ürün title:', products.slice(0, 3).map(p => p.title || 'BOŞ'));

    // DEBUG: CEPLI içeren ürün sayısı
    const cepliCount = products.filter(p => (p.title || '').toUpperCase().includes('CEPLI') || (p.title || '').toUpperCase().includes('CEPLİ')).length;
    console.log(`[TitleFilter] DEBUG - CEPLI içeren ürün sayısı: ${cepliCount}/${products.length}`);

    return products.filter(product => {
      // Title'ı büyük harfe çevir (case-insensitive eşleştirme için)
      const title = (product.title || '').toUpperCase();

      // Her aktif filtre kategorisi için kontrol
      for (const [filterKey, selectedValues] of Object.entries(this.activeFilters)) {
        if (selectedValues.length === 0) continue;

        const config = this.filterConfig[filterKey];
        if (!config) continue;

        // Seçilen değerlerden en az biri eşleşmeli (OR mantığı)
        let matchFound = false;

        for (const selectedValue of selectedValues) {
          // Cepsiz özel mantık (sadece ev giyim için)
          if (filterKey === 'cep_detay' && selectedValue === 'Cepsiz') {
            const cepliKeywords = this.filterConfig.cep_detay['Cepli'] || [];
            const hasCepli = cepliKeywords.some(kw => title.includes(kw));
            if (!hasCepli) {
              matchFound = true;
              break;
            }
          } else {
            const keywords = config[selectedValue] || [];

            // İç giyim için özel kontroller (Destekli/Desteksiz çakışması)
            if (this.isUnderwearCollection && filterKey === 'ic_model_detay') {
              // "Destekli" ararken sadece tam "Destekli" olanları göster
              // "Desteksiz", "Çift Destekli", "Yarım Destekli" hariç tutulacak
              if (selectedValue === 'Destekli') {
                const hasDestekli = keywords.some(kw => title.includes(kw.toUpperCase()));
                const hasDesteksiz = title.includes('DESTEKSIZ') || title.includes('DESTEKSİZ');
                const hasCiftDestekli = title.includes('CIFT DESTEKLI') || title.includes('ÇİFT DESTEKLİ') || title.includes('ÇIFT DESTEKLI');
                const hasYarimDestekli = title.includes('YARIM DESTEKLI') || title.includes('YARIM DESTEKLİ');
                if (hasDestekli && !hasDesteksiz && !hasCiftDestekli && !hasYarimDestekli) {
                  matchFound = true;
                  break;
                }
              }
              // "Yarım Destekli" ararken sadece tam eşleşme
              else if (selectedValue === 'Yarım Destekli') {
                const hasYarimDestekli = title.includes('YARIM DESTEKLI') || title.includes('YARIM DESTEKLİ');
                if (hasYarimDestekli) {
                  matchFound = true;
                  break;
                }
              }
              // "Çift Destekli" ararken sadece tam eşleşme
              else if (selectedValue === 'Çift Destekli') {
                const hasCiftDestekli = title.includes('CIFT DESTEKLI') || title.includes('ÇİFT DESTEKLİ');
                if (hasCiftDestekli) {
                  matchFound = true;
                  break;
                }
              }
              // Diğer iç giyim filtreleri normal şekilde
              else {
                const hasKeyword = keywords.some(kw => title.includes(kw.toUpperCase()));
                if (hasKeyword) {
                  matchFound = true;
                  break;
                }
              }
            } else {
              // Ev giyim ve diğer filtreler için normal kontrol
              const hasKeyword = keywords.some(kw => title.includes(kw.toUpperCase()));
              if (hasKeyword) {
                matchFound = true;
                break;
              }
            }
          }
        }

        // Bu kategoride eşleşme yoksa ürün filtrelenir
        if (!matchFound) {
          return false;
        }
      }

      return true;
    });
  }

  // Filtrelenmiş ürünleri render et
  renderFilteredProducts(products) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    // Pagination'ı gizle
    const pagination = document.querySelector('.wt-pagination-wrapper');
    if (pagination) pagination.style.display = 'none';

    // Ürün sayısını güncelle
    this.updateProductCount(products.length);

    if (products.length === 0) {
      grid.innerHTML = '<div class="collection__empty" style="text-align:center;padding:40px;grid-column:1/-1;">Seçilen filtrelere uygun ürün bulunamadı.</div>';
      return;
    }

    // Orijinal HTML'leri kullan
    grid.innerHTML = products.map(p => p.html).join('');

    // Animasyonları tetikle (DOM element gönder, string değil)
    if (typeof initializeScrollAnimationTrigger === 'function') {
      try {
        initializeScrollAnimationTrigger(grid);
      } catch (e) {
        // Animasyon hatası kritik değil, devam et
      }
    }
  }

  // Ürün sayısını güncelle
  updateProductCount(count) {
    const counters = document.querySelectorAll('#ProductCount, #ProductCountDesktop');
    counters.forEach(counter => {
      counter.textContent = `${count} ürün`;
    });
  }

  // Loading göster
  showLoading() {
    const grid = document.getElementById('product-grid');
    if (grid) {
      grid.style.opacity = '0.5';
      grid.style.pointerEvents = 'none';
    }

    // Spinner
    let loader = document.getElementById('title-filter-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'title-filter-loader';
      loader.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;z-index:9999;';
      loader.innerHTML = `
        <div style="width:40px;height:40px;border:3px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:tf-spin 0.8s linear infinite;"></div>
        <style>@keyframes tf-spin{to{transform:rotate(360deg)}}</style>
      `;
      document.body.appendChild(loader);
    }
  }

  // Loading gizle
  hideLoading() {
    const grid = document.getElementById('product-grid');
    if (grid) {
      grid.style.opacity = '';
      grid.style.pointerEvents = '';
    }

    const loader = document.getElementById('title-filter-loader');
    if (loader) {
      loader.remove();
    }
  }
}

// Sayfa yüklendiğinde başlat (defer script için uygun)
function initTitleFilterSystem() {
  // Sadece collection sayfalarında çalış
  if (window.location.pathname.includes('/collections/')) {
    window.titleFilterSystem = new TitleFilterSystem();
  }
}

// DOM hazır mı kontrol et (defer script için)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTitleFilterSystem);
} else {
  // DOM zaten hazır, hemen başlat
  initTitleFilterSystem();
}

/* ===================== METAFIELD TARİH SIRALAMA SİSTEMİ ===================== */
/* Storefront API GraphQL ile hızlı yükleme - 250 ürün/istek */

class MetafieldDateSorter {
  constructor() {
    this.isActive = false;
    this.allProducts = null; // Tüm ürünler cache
    this.sortedProducts = null; // Sıralanmış ürünler
    this.isLoading = false;
    this.loadingPromise = null;
    this.originalHTML = null;
    this.originalPaginationHTML = null;
    this.currentOrder = 'desc'; // Varsayılan: yeniden eskiye

    // Pagination config
    this.currentPage = 1;
    this.productsPerPage = 120; // Sayfa başına ürün sayısı

    // Storefront API Config
    this.storefrontToken = '7b4572c438c193f463560a3afeca68fa';
    this.apiVersion = '2024-10';

    // Grup fiyatlandırma config
    this.customerGroup = this.detectCustomerGroup();
    this.defaultGroup = window.groupPricingConfig?.defaultGroup || 'Grup1';

    this.init();
  }

  // Müşteri grubunu tespit et
  detectCustomerGroup() {
    // 1. window.customerGroup - doğrudan global değişken (group-pricing.liquid tarafından en erken set edilir)
    if (window.customerGroup) {
      console.log('[MetafieldSort] 👤 Müşteri grubu (customerGroup):', window.customerGroup);
      return window.customerGroup;
    }

    // 2. window.groupPricingConfig'den al
    if (window.groupPricingConfig?.customerGroup) {
      console.log('[MetafieldSort] 👤 Müşteri grubu (groupPricingConfig):', window.groupPricingConfig.customerGroup);
      return window.groupPricingConfig.customerGroup;
    }

    // 3. window.groupPricingSystem'den al (class instance)
    if (window.groupPricingSystem?.config?.customerGroup) {
      console.log('[MetafieldSort] 👤 Müşteri grubu (groupPricingSystem):', window.groupPricingSystem.config.customerGroup);
      return window.groupPricingSystem.config.customerGroup;
    }

    // 4. window.customerData'dan al
    if (window.customerData?.tags) {
      for (const tag of window.customerData.tags) {
        if (tag.includes('Grup') || tag.includes('Group')) {
          console.log('[MetafieldSort] 👤 Müşteri grubu (customerData):', tag);
          return tag;
        }
      }
    }

    // 5. DOM'dan müşteri bilgisi al (meta tag veya data attribute)
    const customerGroupMeta = document.querySelector('meta[name="customer-group"]');
    if (customerGroupMeta) {
      console.log('[MetafieldSort] 👤 Müşteri grubu (meta):', customerGroupMeta.content);
      return customerGroupMeta.content;
    }

    console.log('[MetafieldSort] 👤 Müşteri grubu bulunamadı, varsayılan kullanılacak');
    return null;
  }

  // Variant'lardan müşteri grubuna uygun fiyatı bul
  getGroupPrice(variants, fallbackPrice) {
    if (!variants || variants.length === 0) {
      return { price: fallbackPrice, currency: 'TRY' };
    }

    const targetGroup = this.customerGroup || this.defaultGroup;

    // 1. Tam eşleşme ara
    for (const variant of variants) {
      // Variant title'dan grup bilgisini al (örn: "Grup1 / Kırmızı / M")
      const variantGroup = variant.title?.split(' / ')[0]?.trim();

      if (this.isGroupMatch(variantGroup, targetGroup)) {
        console.log(`[MetafieldSort] 💰 Grup eşleşti: ${variantGroup} = ${targetGroup}, Fiyat: ${variant.price}`);
        return { price: variant.price, currency: variant.currency };
      }

      // selectedOptions'dan da kontrol et
      const groupOption = variant.options?.find(opt =>
        opt.name?.toLowerCase().includes('grup') ||
        opt.name?.toLowerCase().includes('fiyat')
      );
      if (groupOption && this.isGroupMatch(groupOption.value, targetGroup)) {
        console.log(`[MetafieldSort] 💰 Grup eşleşti (option): ${groupOption.value} = ${targetGroup}, Fiyat: ${variant.price}`);
        return { price: variant.price, currency: variant.currency };
      }
    }

    // 2. Varsayılan gruba fallback
    if (targetGroup !== this.defaultGroup) {
      for (const variant of variants) {
        const variantGroup = variant.title?.split(' / ')[0]?.trim();
        if (this.isGroupMatch(variantGroup, this.defaultGroup)) {
          console.log(`[MetafieldSort] 💰 Varsayılan grup kullanıldı: ${this.defaultGroup}, Fiyat: ${variant.price}`);
          return { price: variant.price, currency: variant.currency };
        }
      }
    }

    // 3. Hiç eşleşme yoksa ilk variant'ın fiyatını kullan
    console.log(`[MetafieldSort] 💰 Eşleşme yok, ilk variant fiyatı: ${variants[0]?.price || fallbackPrice}`);
    return { price: variants[0]?.price || fallbackPrice, currency: variants[0]?.currency || 'TRY' };
  }

  // Grup eşleştirme (esnek karşılaştırma)
  isGroupMatch(variantGroup, targetGroup) {
    if (!variantGroup || !targetGroup) return false;

    const normalizedVariant = variantGroup.toLowerCase().trim().replace(/[.\s]/g, '');
    const normalizedTarget = targetGroup.toLowerCase().trim().replace(/[.\s]/g, '');

    return normalizedVariant === normalizedTarget;
  }

  init() {
    // Sadece collection sayfalarında çalış
    if (!window.location.pathname.includes('/collections/')) return;

    console.log('[MetafieldSort] ✅ Başlatıldı (Storefront API mode)');

    // Sort select'i dinle
    this.observeSortChange();

    // URL'den sıralama kontrolü
    this.checkURLForCustomSort();

    // facets:change event'ini dinle - Shopify filtreleme sonrası yeniden yükle
    document.addEventListener('facets:change', () => {
      if (!this.isActive) return;
      console.log('[MetafieldSort] 🔄 facets:change - ürünler yeniden yüklenecek');
      // Cache'i temizle ve yeniden yükle
      this.allProducts = null;
      this.loadingPromise = null;
      this.originalHTML = null;

      setTimeout(() => {
        this.applyDateSort(this.currentOrder);
      }, 300);
    });

    // Varsayılan sıra sunucudan gelir (koleksiyonlar create_date'e göre elle sıralı); yalnız menüden/URL'den seçilince uygulanır.
    if (this.isActive) {
      setTimeout(() => this.applyDateSort(this.currentOrder), 100);
    }
  }

  // Sort değişikliğini dinle
  observeSortChange() {
    // custom-select değişikliğini dinle
    document.addEventListener('wtSelectChange', (e) => {
      const value = e.detail?.value;
      if (value === 'metafield-date-desc' || value === 'metafield-date-asc') {
        console.log(`[MetafieldSort] 📅 Metafield sıralama seçildi: ${value}`);
        e.stopPropagation();
        this.isActive = true;
        const order = value === 'metafield-date-asc' ? 'asc' : 'desc';
        this.currentOrder = order;
        this.applyDateSort(order);
        this.updateURL(value);
      } else if (this.isActive) {
        // Başka sıralama seçildi, normal Shopify davranışına dön
        console.log('[MetafieldSort] 🔄 Normal sıralamaya dönülüyor');
        this.isActive = false;
        this.removeCustomSortFromURL();
        this.restoreOriginalGrid();
      }
    });

    // Ayrıca select element change'ini de dinle (fallback)
    const sortByInput = document.getElementById('SortBy');
    if (sortByInput) {
      sortByInput.addEventListener('change', (e) => {
        const value = e.target.value;
        if (value === 'metafield-date-desc' || value === 'metafield-date-asc') {
          e.preventDefault();
          e.stopPropagation();
          this.isActive = true;
          const order = value === 'metafield-date-asc' ? 'asc' : 'desc';
          this.currentOrder = order;
          this.applyDateSort(order);
          this.updateURL(value);
        }
      });
    }
  }

  // URL'de custom sort var mı kontrol et
  checkURLForCustomSort() {
    const params = new URLSearchParams(window.location.search);
    const customSort = params.get('custom_sort');

    if (customSort === 'metafield-date-desc' || customSort === 'metafield-date-asc') {
      console.log(`[MetafieldSort] 📥 URL'den sıralama yüklendi: ${customSort}`);
      this.isActive = true;
      this.currentOrder = customSort === 'metafield-date-asc' ? 'asc' : 'desc';
    }
  }

  // Collection handle'ını URL'den al
  getCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  // Storefront API GraphQL sorgusu
  async graphqlQuery(query, variables = {}) {
    const response = await fetch(`/api/${this.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontToken
      },
      body: JSON.stringify({ query, variables })
    });

    if (!response.ok) {
      throw new Error(`GraphQL error: ${response.status}`);
    }

    const result = await response.json();
    if (result.errors) {
      console.error('[MetafieldSort] GraphQL errors:', result.errors);
      throw new Error(result.errors[0].message);
    }

    return result.data;
  }

  // Tüm ürünleri yükle - ÖNCE HTML'den kartları al, SONRA API'den metafield/fiyat
  // Bu sayede tema kartları ve çeviriler korunur
  async loadAllProducts() {
    if (this.isLoading) {
      if (this.loadingPromise) await this.loadingPromise;
      return;
    }
    this.isLoading = true;
    this.showLoading();

    const collectionHandle = this.getCollectionHandle();
    if (!collectionHandle) {
      console.error('[MetafieldSort] ❌ Collection handle bulunamadı');
      this.isLoading = false;
      this.hideLoading();
      return;
    }

    console.log(`[MetafieldSort] 🚀 Hibrit yükleme: HTML + Storefront API`);
    const startTime = Date.now();

    try {
      // 1. ADIM: Tüm sayfalardan orijinal HTML kartlarını al
      console.log('[MetafieldSort] 📄 HTML kartları yükleniyor...');
      const htmlProducts = await this.loadAllProductsFromHTML();
      console.log(`[MetafieldSort] 📄 HTML'den ${htmlProducts.length} ürün yüklendi`);

      // 2. ADIM: Storefront API'den metafield tarihleri ve grup fiyatlarını al
      console.log('[MetafieldSort] 🔗 API\'den tarih ve fiyat bilgisi alınıyor...');
      const apiData = await this.fetchMetafieldAndPriceData(collectionHandle);
      console.log(`[MetafieldSort] 🔗 API'den ${Object.keys(apiData).length} ürün verisi alındı`);

      // 3. ADIM: HTML kartlarını API verileriyle birleştir
      this.allProducts = htmlProducts.map(product => {
        const handle = product.handle;
        const apiProduct = apiData[handle];

        if (apiProduct) {
          // API'den gelen tarih ve fiyat bilgisini ekle
          return {
            ...product,
            date: apiProduct.date || product.date || '',
            hasMetafield: apiProduct.hasMetafield || false,
            groupPrice: apiProduct.groupPrice,
            currency: apiProduct.currency
          };
        }
        return product;
      });

      const elapsed = ((Date.now() - startTime) / 1000).toFixed(2);
      console.log(`[MetafieldSort] ✅ Toplam: ${this.allProducts.length} ürün (${elapsed}s)`);

    } catch (error) {
      console.error('[MetafieldSort] ❌ Yükleme hatası:', error);
      // Son çare: Mevcut DOM'dan al
      this.allProducts = this.getProductsFromDOM();
      console.log(`[MetafieldSort] ⚠️ DOM Fallback: ${this.allProducts.length} ürün`);
    } finally {
      this.isLoading = false;
      this.loadingPromise = null;
      this.hideLoading();
    }
  }

  // Storefront API'den sadece metafield ve fiyat bilgisi al (HTML kartları için)
  async fetchMetafieldAndPriceData(collectionHandle) {
    const productData = {};

    try {
      let hasNextPage = true;
      let cursor = null;

      const query = `
        query getCollectionProducts($handle: String!, $first: Int!, $after: String) {
          collection(handle: $handle) {
            products(first: $first, after: $after) {
              pageInfo {
                hasNextPage
                endCursor
              }
              nodes {
                handle
                variants(first: 20) {
                  nodes {
                    title
                    price {
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
                createDate: metafield(namespace: "custom", key: "create_date") {
                  value
                }
              }
            }
          }
        }
      `;

      while (hasNextPage) {
        const data = await this.graphqlQuery(query, {
          handle: collectionHandle,
          first: 250,
          after: cursor
        });

        if (!data.collection) break;

        const products = data.collection.products;
        const nodes = products.nodes || [];

        nodes.forEach(node => {
          const dateValue = node.createDate?.value || '';
          const variants = (node.variants?.nodes || []).map(v => ({
            title: v.title,
            price: v.price?.amount || '0',
            currency: v.price?.currencyCode || 'TRY',
            options: v.selectedOptions || []
          }));

          // Müşteri grubuna göre doğru fiyatı bul
          const groupPrice = this.getGroupPrice(variants, variants[0]?.price || '0');

          productData[node.handle] = {
            date: dateValue,
            hasMetafield: dateValue !== '',
            groupPrice: groupPrice.price,
            currency: groupPrice.currency
          };
        });

        hasNextPage = products.pageInfo.hasNextPage;
        cursor = products.pageInfo.endCursor;

        if (hasNextPage) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
      }
    } catch (error) {
      console.warn('[MetafieldSort] ⚠️ API veri alınamadı:', error.message);
    }

    return productData;
  }

  // HTML sayfalarından tüm ürünleri yükle (orijinal tema kartlarını korur)
  async loadAllProductsFromHTML() {
    const allProducts = [];

    // İlk sayfayı DOM'dan al
    const firstPageProducts = this.getProductsFromDOM();
    allProducts.push(...firstPageProducts);
    console.log(`[MetafieldSort] 📄 HTML S1: ${firstPageProducts.length} ürün`);

    // Toplam sayfa sayısını bul
    const paginationLinks = document.querySelectorAll('.wt-pagination .wt-pagination__item');
    let maxPage = 1;
    paginationLinks.forEach(link => {
      const text = link.textContent.trim();
      const num = parseInt(text);
      if (!isNaN(num) && num > maxPage) {
        maxPage = num;
      }
    });

    console.log(`[MetafieldSort] 📄 Toplam sayfa: ${maxPage}`);

    if (maxPage <= 1) {
      return allProducts;
    }

    // Diğer sayfaları paralel yükle (3'erli gruplar)
    const pagesToFetch = [];
    for (let p = 2; p <= maxPage; p++) {
      pagesToFetch.push(p);
    }

    const chunkSize = 3;
    for (let i = 0; i < pagesToFetch.length; i += chunkSize) {
      const chunk = pagesToFetch.slice(i, i + chunkSize);
      console.log(`[MetafieldSort] 📄 S${chunk.join(',')} yükleniyor...`);

      const results = await Promise.all(
        chunk.map(page => this.fetchHTMLPage(page))
      );

      results.forEach((pageProducts, idx) => {
        allProducts.push(...pageProducts);
        console.log(`[MetafieldSort] 📄 HTML S${chunk[idx]}: ${pageProducts.length} ürün`);
      });

      // Rate limiting
      if (i + chunkSize < pagesToFetch.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    return allProducts;
  }

  // HTML'den handle çıkar (ürün linkinden)
  extractHandleFromHTML(html) {
    // href="/products/xxxxx" pattern'ini bul
    const match = html.match(/href="\/products\/([^"\/\?]+)/);
    return match ? match[1] : null;
  }

  // Tek HTML sayfası fetch et
  async fetchHTMLPage(page) {
    try {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('page', page);
      const url = `${window.location.pathname}?${currentParams.toString()}`;

      const response = await fetch(url);
      if (!response.ok) return [];

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const products = [];
      doc.querySelectorAll('#product-grid .collection__grid__item').forEach(item => {
        const card = item.querySelector('.card__container');
        const productDate = card?.dataset?.productDate || '';
        const hasMetafieldDate = card?.dataset?.hasMetafieldDate === 'true';
        const itemHtml = item.outerHTML;
        // Handle'ı ürün linkinden çıkar
        const handle = this.extractHandleFromHTML(itemHtml);
        products.push({
          html: itemHtml,
          handle: handle,
          date: productDate,
          hasMetafield: hasMetafieldDate
        });
      });
      return products;
    } catch (e) {
      console.error(`[MetafieldSort] ❌ Sayfa ${page} yüklenemedi:`, e);
      return [];
    }
  }

  // DOM'dan mevcut ürünleri al (orijinal tema kartlarını korur)
  getProductsFromDOM() {
    const products = [];
    document.querySelectorAll('#product-grid .collection__grid__item').forEach(item => {
      const card = item.querySelector('.card__container');
      const productDate = card?.dataset?.productDate || '';
      const hasMetafieldDate = card?.dataset?.hasMetafieldDate === 'true';
      const itemHtml = item.outerHTML;
      // Handle'ı ürün linkinden çıkar
      const handle = this.extractHandleFromHTML(itemHtml);
      products.push({
        html: itemHtml,
        handle: handle,
        date: productDate,
        hasMetafield: hasMetafieldDate
      });
    });
    return products;
  }

  // Tarihe göre sırala (TÜM SAYFALARI YÜKLEYEREK + CLIENT-SIDE PAGINATION)
  async applyDateSort(order = 'desc') {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      console.warn('[MetafieldSort] ⚠️ Grid bulunamadı');
      return;
    }

    // Orijinal HTML'i kaydet (ilk seferde)
    if (!this.originalHTML) {
      this.originalHTML = grid.innerHTML;
    }

    // Orijinal pagination'ı kaydet
    const pagination = document.querySelector('.wt-pagination-wrapper');
    if (!this.originalPaginationHTML && pagination) {
      this.originalPaginationHTML = pagination.innerHTML;
    }

    // Ürünler yüklenmemişse yükle
    if (!this.allProducts || this.allProducts.length === 0) {
      this.loadingPromise = this.loadAllProducts();
      await this.loadingPromise;
    }

    if (!this.allProducts || this.allProducts.length === 0) {
      console.warn('[MetafieldSort] ⚠️ Ürün bulunamadı');
      return;
    }

    // Debug: Kaç üründe metafield var?
    let withMetafield = 0;
    let withoutMetafield = 0;
    this.allProducts.forEach(product => {
      if (product.hasMetafield) withMetafield++;
      else withoutMetafield++;
    });
    console.log(`[MetafieldSort] 📊 ${this.allProducts.length} ürün (${withMetafield} metafield VAR, ${withoutMetafield} metafield YOK)`);

    // Ürünleri tarihe göre sırala (metafield olmayanlar en sona)
    this.sortedProducts = [...this.allProducts].sort((a, b) => {
      // Metafield olmayanlar en sona
      if (!a.hasMetafield && b.hasMetafield) return 1;
      if (a.hasMetafield && !b.hasMetafield) return -1;
      if (!a.hasMetafield && !b.hasMetafield) return 0;

      // Her ikisinde de metafield var, tarihe göre sırala
      const dateA = this.parseDate(a.date);
      const dateB = this.parseDate(b.date);

      if (order === 'desc') {
        return dateB - dateA; // Yeniden eskiye
      } else {
        return dateA - dateB; // Eskiden yeniye
      }
    });

    // Debug: İlk 5 ürünün tarihlerini göster
    console.log('[MetafieldSort] 📅 İlk 5 ürün tarihi:');
    this.sortedProducts.slice(0, 5).forEach((p, i) => {
      console.log(`  ${i+1}. ${p.date} (hasMetafield: ${p.hasMetafield})`);
    });

    // İlk sayfadan başla
    this.currentPage = 1;
    this.renderCurrentPage();

    console.log(`[MetafieldSort] ✅ Sıralama tamamlandı: ${this.sortedProducts.length} ürün (${order === 'desc' ? 'Yeniden Eskiye' : 'Eskiden Yeniye'})`);
  }

  // Mevcut sayfayı render et (orijinal tema kartlarını kullanır)
  renderCurrentPage() {
    const grid = document.getElementById('product-grid');
    if (!grid || !this.sortedProducts) return;

    const totalProducts = this.sortedProducts.length;
    const totalPages = Math.ceil(totalProducts / this.productsPerPage);
    const startIndex = (this.currentPage - 1) * this.productsPerPage;
    const endIndex = Math.min(startIndex + this.productsPerPage, totalProducts);
    const pageProducts = this.sortedProducts.slice(startIndex, endIndex);

    console.log(`[MetafieldSort] 📄 Sayfa ${this.currentPage}/${totalPages} (${startIndex + 1}-${endIndex} / ${totalProducts})`);

    // Grid'i güncelle - HER ZAMAN orijinal HTML kartlarını kullan
    grid.innerHTML = pageProducts.map((p, index) => {
      if (!p.html) {
        console.warn('[MetafieldSort] ⚠️ Ürün HTML\'i bulunamadı:', p.handle);
        return '';
      }
      // Animasyon sırası ekle
      let html = p.html.replace('data-cascade', `data-cascade style="--animation-order: ${index + 1}"`);
      // group-pricing-loaded class'ı ekle (fiyat görünürlüğü için)
      html = html.replace('class="card__container', 'class="card__container group-pricing-loaded');
      return html;
    }).join('');

    // Grup fiyatlarını DOM üzerinden güncelle (müşteri login ise)
    if (this.customerGroup) {
      this.updatePricesInDOM(grid, pageProducts);
    }

    // Tüm card container'lara group-pricing-loaded ekle
    grid.querySelectorAll('.card__container').forEach(card => {
      card.classList.add('group-pricing-loaded');
    });

    // Pagination'ı güncelle
    this.renderPagination(totalPages);

    // Ürün sayısını güncelle
    this.updateProductCount(totalProducts);

    // Sayfanın üstüne scroll
    if (this.currentPage > 1) {
      const gridTop = grid.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: gridTop, behavior: 'smooth' });
    }

    // Animasyonları tetikle
    if (typeof initializeScrollAnimationTrigger === 'function') {
      try {
        initializeScrollAnimationTrigger(grid);
      } catch (e) {}
    }
  }

  // DOM üzerinden fiyatları güncelle (orijinal kartları bozmadan)
  updatePricesInDOM(grid, products) {
    const cards = grid.querySelectorAll('.collection__grid__item');

    cards.forEach((card, index) => {
      const product = products[index];
      if (!product || !product.groupPrice) return;

      // Fiyat elementini bul
      const priceElement = card.querySelector('.price-item--regular, .price-item, .money, .glc-money');
      if (priceElement) {
        const price = parseFloat(product.groupPrice).toLocaleString('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        const currencySymbol = product.currency === 'TRY' ? '₺' : (product.currency || '₺');
        priceElement.textContent = `${currencySymbol}${price}`;
      }
    });
  }

  // Client-side pagination render (tema yapısına uygun)
  renderPagination(totalPages) {
    const paginationWrapper = document.querySelector('.wt-pagination-wrapper');
    if (!paginationWrapper) return;

    if (totalPages <= 1) {
      paginationWrapper.style.display = 'none';
      return;
    }

    paginationWrapper.style.display = '';

    // Tema yapısına uygun pagination HTML
    let paginationHTML = '<nav class="wt-pagination" role="navigation" aria-label="Sayfalama">';
    paginationHTML += '<ul class="wt-pagination__list list-unstyled" role="list">';

    // Önceki sayfa butonu
    if (this.currentPage > 1) {
      paginationHTML += `
        <li>
          <a href="#" class="wt-pagination__item wt-pagination__item--next wt-pagination__item-arrow link motion-reduce" data-page="${this.currentPage - 1}" aria-label="Önceki">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
          </a>
        </li>
      `;
    }

    // Sayfa numaraları
    const maxVisiblePages = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // İlk sayfa
    if (startPage > 1) {
      paginationHTML += `<li><a href="#" class="wt-pagination__item link" data-page="1">1</a></li>`;
      if (startPage > 2) {
        paginationHTML += `<li><span class="wt-pagination__item">&hellip;</span></li>`;
      }
    }

    // Orta sayfalar
    for (let i = startPage; i <= endPage; i++) {
      if (i === this.currentPage) {
        paginationHTML += `<li><span class="wt-pagination__item wt-pagination__item--current" aria-current="page">${i}</span></li>`;
      } else {
        paginationHTML += `<li><a href="#" class="wt-pagination__item link" data-page="${i}">${i}</a></li>`;
      }
    }

    // Son sayfa
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationHTML += `<li><span class="wt-pagination__item">&hellip;</span></li>`;
      }
      paginationHTML += `<li><a href="#" class="wt-pagination__item link" data-page="${totalPages}">${totalPages}</a></li>`;
    }

    // Sonraki sayfa butonu
    if (this.currentPage < totalPages) {
      paginationHTML += `
        <li>
          <a href="#" class="wt-pagination__item wt-pagination__item--prev wt-pagination__item-arrow link motion-reduce" data-page="${this.currentPage + 1}" aria-label="Sonraki">
            <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
          </a>
        </li>
      `;
    }

    paginationHTML += '</ul></nav>';

    paginationWrapper.innerHTML = paginationHTML;

    // Click event'lerini ekle
    paginationWrapper.querySelectorAll('[data-page]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const page = parseInt(link.dataset.page);
        if (page !== this.currentPage) {
          this.currentPage = page;
          this.renderCurrentPage();
        }
      });
    });
  }

  // Ürün sayısını güncelle
  updateProductCount(count) {
    const counters = document.querySelectorAll('#ProductCount, #ProductCountDesktop');
    counters.forEach(counter => {
      counter.textContent = `${count} ürün`;
    });
  }

  // Orijinal grid'i geri yükle
  restoreOriginalGrid() {
    const grid = document.getElementById('product-grid');
    const pagination = document.querySelector('.wt-pagination-wrapper');

    if (this.originalHTML && grid) {
      grid.innerHTML = this.originalHTML;
    }

    if (this.originalPaginationHTML && pagination) {
      pagination.innerHTML = this.originalPaginationHTML;
      pagination.style.display = '';
    }

    // Cache'i temizle
    this.sortedProducts = null;
    this.currentPage = 1;
  }

  // Loading göster (arka planda, engellemeden)
  showLoading() {
    // Artık tam ekran overlay kullanmıyoruz
    // Sadece küçük bir indicator göster (opsiyonel)
    let loader = document.getElementById('metafield-sort-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'metafield-sort-loader';
      // Küçük, köşede, engellemez
      loader.style.cssText = 'position:fixed;bottom:20px;right:20px;background:rgba(0,0,0,0.7);color:#fff;padding:10px 15px;border-radius:8px;z-index:999;display:flex;align-items:center;gap:10px;font-size:13px;pointer-events:none;';
      loader.innerHTML = `
        <div style="width:16px;height:16px;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;animation:mds-spin 0.8s linear infinite;"></div>
        <span>Yükleniyor...</span>
        <style>@keyframes mds-spin{to{transform:rotate(360deg)}}</style>
      `;
      document.body.appendChild(loader);
    }
  }

  // Loading gizle
  hideLoading() {
    const loader = document.getElementById('metafield-sort-loader');
    if (loader) {
      loader.remove();
    }
  }

  // Tarih string'ini parse et
  // Format: 2024-08-19T21:00:00.000Z (ISO 8601)
  parseDate(dateStr) {
    // Tarih yoksa veya boşsa
    if (!dateStr || dateStr.trim() === '') {
      return new Date(0);
    }

    // ISO format: 2024-01-15T10:30:00.000Z
    let date = new Date(dateStr);

    // Geçerli tarih mi kontrol et
    if (!isNaN(date.getTime())) {
      return date;
    }

    // Alternatif formatlar dene (DD.MM.YYYY veya DD/MM/YYYY)
    const parts = dateStr.split(/[.\/\-]/);
    if (parts.length === 3) {
      const [a, b, c] = parts.map(p => parseInt(p, 10));

      if (c > 1000) {
        // DD.MM.YYYY formatı
        date = new Date(c, b - 1, a);
      } else if (a > 1000) {
        // YYYY-MM-DD formatı
        date = new Date(a, b - 1, c);
      }

      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    console.warn(`[MetafieldSort] ⚠️ Tarih parse edilemedi: ${dateStr}`);
    return new Date(0);
  }

  // URL'i güncelle
  updateURL(sortValue) {
    const params = new URLSearchParams(window.location.search);
    params.set('custom_sort', sortValue);
    // Shopify'ın sort_by parametresini kaldır (çakışmasın)
    params.delete('sort_by');

    const newURL = `${window.location.pathname}?${params.toString()}`;
    history.replaceState(null, '', newURL);
  }

  // Custom sort'u URL'den kaldır
  removeCustomSortFromURL() {
    const params = new URLSearchParams(window.location.search);
    params.delete('custom_sort');

    const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    history.replaceState(null, '', newURL);
  }
}

// Metafield sıralama sistemini başlat
// DEVRE DIŞI - TitleFilterSystem ile çakışıyor
/*
function initMetafieldDateSorter() {
  if (window.location.pathname.includes('/collections/')) {
    window.metafieldDateSorter = new MetafieldDateSorter();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMetafieldDateSorter);
} else {
  initMetafieldDateSorter();
}
*/